import { Theme, css } from '@emotion/react';

export const drawerFooter = ({ spacing }: Theme) => css`
  color: green;
  & > * + * {
    margin-top: ${spacing(1)}px;
  }
`;

export const availabilityMetadataContainer = ({ colors, spacing, borderRadius }: Theme) => css`
  background: ${colors.bgLighter};
  border-radius: ${borderRadius[100]};
  padding: ${spacing(2)}px ${spacing(1.5)}px;
  & > * + * {
    margin-top: ${spacing(1.25)}px;
  }
`;

export const metadataItem = css`
  display: flex;
  align-items: flex-start;
`;

export const metadataItemLabel = ({ spacing }: Theme) => css`
  margin-left: ${spacing(1)}px;
`;

export const metadataItemSkeletonLabel = ({ colors, spacing }: Theme) => css`
  background-color: ${colors.bgLight};
  margin-left: ${spacing(1)}px;
`;

export const metadataItemTicketTypeName = css`
  display: block;
`;

export const availableSlotStateIndicatorLabel = ({ spacing }: Theme) => css`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(0.5)}px;
  gap: ${spacing(0.5)}px;
`;

export const availableSlotStateIndicatorContainer = ({ spacing }: Theme) => css`
  padding: 0 0 ${spacing(2)}px;
`;
